import api from './apiClient';

const employeeApi = {
  getEmployees: () => api.get('/hr/employees'),
  getEmployeeById: (id) => api.get(`/hr/employees/${id}`),
  createEmployee: (data) => api.post('/hr/employees', data),
  updateEmployee: (id, data) => api.put(`/hr/employees/${id}`, data),
  deleteEmployee: (id) => api.delete(`/hr/employees/${id}`),
  searchEmployees: (searchTerm) => api.get(`/hr/employees/search?q=${searchTerm}`),
  getEmployeesByDepartment: (departmentId) => api.get(`/hr/employees/department/${departmentId}`),
  getEmployeesByRole: (role) => api.get(`/hr/employees/role/${role}`),
  getActiveEmployees: () => api.get('/hr/employees/active'),
  getEmployeeProfile: (id) => api.get(`/hr/employees/${id}/profile`),
  updateEmployeeProfile: (id, data) => api.put(`/hr/employees/${id}/profile`, data),
  getEmployeePerformance: (id) => api.get(`/hr/employees/${id}/performance`),
  getEmployeeGoals: (id) => api.get(`/hr/employees/${id}/goals`),
  getEmployeeReviews: (id) => api.get(`/hr/employees/${id}/reviews`),
  getEmployeePicker: (params = {}) => api.get('/hr/employees/picker', { params }),
  getSalesReps: () => api.get('/hr/employees/sales-reps')
};

export { employeeApi };

